import { useCallback } from 'react';
import { SEARCH_MIN_CHARS } from '../constants';

type Params = {
	searchTerm: string;
	runSearch: (term: string) => void;
	cleanUp: () => void;
};

export function useDefaultSearchAction({ searchTerm, runSearch, cleanUp }: Params) {
	return useCallback(
		(recentSearchTerm?: string) => {
			const termToSearch = recentSearchTerm || searchTerm;

			if (termToSearch.length < SEARCH_MIN_CHARS) {
				return;
			}

			runSearch(termToSearch);
			cleanUp();
		},
		[searchTerm, runSearch, cleanUp],
	);
}
